module.exports = __webpack_public_path__ + "static/media/flag-yo.5a1abd8d.webp";